import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import { device, merchantThemes } from 'components/Variable'

export const Attr = styled.div`
	font-weight: 600;
	font-size: ${rem(18)};
	line-height: ${rem(25)};
	display: flex;
	align-items: center;

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-weight: normal;
		`}

	@media (${device.tablet}) {
		font-size: ${rem(14)};
		line-height: ${rem(19)};
		font-weight: 400;
	}
	${(p) =>
		p.isOrdersPage === true &&
		css`
			@media (${device.mobileL}) {
				flex-direction: column;
				align-items: start;
			}
		`}
	${(p) =>
		p.isOrdersPage === true &&
		p.theme.name === merchantThemes.marysia &&
		css`
			@media (${device.mobileXL}) {
				display: none;
			}
		`}
	${(p) =>
		p.size === 'large' &&
		css`
			font-size: ${rem(18)};
			line-height: ${rem(25)};
		`}
	${(p) =>
		p.size === 'small' &&
		css`
			font-size: ${rem(14)};
			line-height: ${rem(19)};
			@media (${device.tablet}) {
				font-size: ${rem(12)};
				line-height: ${rem(16)};
			}
		`}
	${(p) =>
		p.isShowOnMobile === false &&
		css`
			@media (${device.mobileXL}) {
				display: none;
			}
		`}
	& > div {
		&::after {
			content: '|';
			display: inline-block;
			margin: ${rem(0, 5)};
			${(p) =>
				p.isOrdersPage === true &&
				css`
					@media (${device.mobileL}) {
						display: none;
					}
				`}
		}
		&:last-child:after {
			content: none;
		}
	}
`
